<script lang="ts">
  import { Button } from '@tomra/design-system-svelte';

  let {
    title = "Couldn't load the app",
    message,
    onRetry,
    retrying = false
  }: {
    title?: string;
    message: string;
    onRetry?: () => void;
    retrying?: boolean;
  } = $props();
</script>

<div
  class="fixed inset-0 z-[9998] flex items-center justify-center bg-white p-8 dark:bg-gray-900"
  role="alert"
  aria-live="assertive"
>
  <div class="flex max-w-lg flex-col items-center text-center">
    <span
      class="icon-[fluent--warning-24-regular] mb-4 text-5xl text-rose-500 dark:text-rose-400"
      aria-hidden="true"
    ></span>
    <h1 class="mb-3 text-2xl font-medium text-gray-950 dark:text-white">{title}</h1>
    <p class="mb-6 text-base leading-relaxed break-words text-gray-600 dark:text-gray-400">
      {message}
    </p>
    {#if onRetry}
      <div class="flex gap-3">
        <Button variant="primary" type="button" onclick={onRetry} disabled={retrying}>
          {retrying ? 'Retrying…' : 'Retry'}
        </Button>
      </div>
    {/if}
  </div>
</div>
